import { render, staticRenderFns } from "./WarehouseView2.vue?vue&type=template&id=2d326c4f&scoped=true"
import script from "./WarehouseView2.vue?vue&type=script&lang=js"
export * from "./WarehouseView2.vue?vue&type=script&lang=js"
import style0 from "./WarehouseView2.vue?vue&type=style&index=0&id=2d326c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d326c4f",
  null
  
)

export default component.exports